










import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist } from '@/classes/playlist'

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Vue {
  get validation(): { message?: string, valid: boolean } {
    return { valid: true }
  }

  async save({ playlist, playlistBefore, newParentPlaylist }: { playlist: Playlist, playlistBefore: Playlist, newParentPlaylist: Playlist }) {
    if (!this.validation.valid) return

    this.$emit('update:loading', true)

    const playlistIds: string[] = newParentPlaylist.playlists.map(x => x._id)

    let beforeIndex: number = playlistBefore ? playlistIds.findIndex(x => x === playlistBefore._id) : -1
    const oldIndex: number = playlistIds.findIndex(x => x === playlist._id)

    if (beforeIndex < oldIndex || oldIndex === -1) beforeIndex += 1

    if (oldIndex !== -1) {
      playlistIds.splice(oldIndex, 1)
    }

    playlistIds.splice(beforeIndex, 0, playlist._id)

    const res = await Axios.post('/playlist/reorder-folder', {
      parentId: newParentPlaylist._id,
      playlistId: playlist._id,
      playlistIds
    })

    if (res && res.data && res.data.playlists) {
      this.$store.commit('library/replacePlaylists', res.data)
    }

    this.$emit('update:loading', false)
  }
}
